module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12je8hm/tc-custom/9781459233713.jpg?1718106103396",
      "alt": "This image is the cover for the book Laird's Forbidden Lady"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Laird's Forbidden Lady\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Passions ignite when a Scottish laird and the daughter of the Englishman who stole his land reunite in this steamy Regency romance.")]), _c('br'), _c('br'), _vm._v("Ian Gilvry, Laird of Dunross, is as rough and wild as the Highland heather. Yet the return of Sassenach Selina and her family to claim his land ignites hatred and passion in equal measure."), _c('br'), _c('br'), _vm._v("Lady Selina is torn between family loyalty and wanton need for Ian. Tricked into marriage, she finds the laird fulfils her every burning desire. But Ian is a man bound by duty. Can Selina be sure that his heart belongs not only to his clan . . . but also to the woman he has made his wife?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ann Lethbridge\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ann Lethbridge majored in history and business. She always loved the glamorous, if rather risky, Georgians and in particular the Regency era as drawn by Georgette Heyer. It was that love that prompted her to write her first Regency novel in 2000. She found she enjoyed it so much she just couldn’t stop! Ann gave up a career in university administration to focus on her first love, writing novels and lives in Canada with her family. Visit her website at: www.annlethbridge.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0